export default __webpack_public_path__ + "static/media/meetingsrestapi.32ec365b.png";